import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    listaFA: [],
    totalPaginas: 5,
  },
  mutations: {
    getFraccionasA(state, datos) {
      state.listaFA = datos[0];
      state.totalPaginas = datos[1];
    },
    destroyFraccionesAStore(state) {
      state.listaFA = [];
      state.totalPaginas = 5;
    },
  },
  actions: {
    async getFraccionasA({
      commit,
    }, fa) {
      try {
        if (fa.textoBusqueda) {
          const res = await api.getFraccionasAWithSearch(fa);
          console.log(res);
          if (res.data.INFO.cod === '200') {
            commit('getFraccionasA', [res.data.DATOS, res.data.INFO.paginacion.Paginas]);
            return [true];
          }
          return [false];
        }
        const res = await api.getFraccionasA(fa);
        if (res.data.INFO.cod === '200') {
          commit('getFraccionasA', [res.data.DATOS, res.data.INFO.paginacion.Paginas]);
          return [true];
        }
        return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },
    async insertFraccionasA({ }, fa) {
      try {
        const res = await api.insertFraccionasA(fa);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async destroyFraccionesAStore({
      commit,
    }) {
      commit('destroyFraccionesAStore');
    },

    async deleteFraccionasA({ }, fa) {
      try {
        const res = await api.deleteFraccionasA(fa);
        console.log(res);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },
    async editFraccionasA({ }, fa) {
      try {
        const res = await api.editFraccionasA(fa);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
